import(/* webpackMode: "eager" */ "/workspace/app/books/components/Products.jsx")